import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";

interface Feature {
  titulo: string;
  descripcion: string;
  icono: string;
}

export default function WhyUs() {
  const { sections } = useSiteContent();
  const content = sections["por-que"] || {};
  const features = (content.features as Feature[]) || [];

  return (
    <section id="por-que" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Por qué elegirnos"
          title={String(content.title || "Por qué elegir MARK DIRECT COMPANY")}
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((item, i) => (
            <Reveal key={`${item.titulo}-${i}`} delay={(i % 3) * 80}>
              <div className="group flex flex-col h-full rounded-2xl border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 hover:shadow-[0_16px_40px_rgba(30,60,120,0.08)]">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-primary-50 to-accent-50 text-primary-600 mb-5">
                  <i className={`${item.icono || "ri-star-line"} text-2xl`} />
                </div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">
                  {item.titulo}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.descripcion}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}